export const NIVELES_EVALUACION = {
  basico: {
    nombre: 'Nivel 1 Básico',
    modulos: {
      Modulo1: [
        { id: 1, nombre: 'Ejercicio 10' },
        { id: 2, nombre: 'Ejercicio 11' },
      ],
      Modulo2: [{ id: 3, nombre: 'Ejercicio 7' }],
      Modulo3: [
        { id: 4, nombre: 'Ejercicio 9' },
        { id: 5, nombre: 'Ejercicio 10' },
      ],
      Modulo4: [
        { id: 6, nombre: 'Ejercicio 7' },
        { id: 7, nombre: 'Ejercicio 8' },
        { id: 8, nombre: 'Ejercicio 9' },
        { id: 9, nombre: 'Ejercicio 10' },
      ],
      Modulo5: [
        { id: 10, nombre: 'Ejercicio 7' },
        { id: 11, nombre: 'Ejercicio 8' },
        { id: 12, nombre: 'Ejercicio 9' },
        { id: 13, nombre: 'Ejercicio 10' },
      ],
    },
  },
  intermedio: {
    nombre: 'Nivel 2 Intermedio',
    modulos: {
      Modulo6: [
        { id: 1, nombre: 'Ejercicio 6' },
        { id: 2, nombre: 'Ejercicio 7' },
        { id: 3, nombre: 'Ejercicio de retención' },
      ],
      Modulo7: [
        { id: 4, nombre: 'Ejercicio de comprensión' },
        { id: 5, nombre: 'Ejercicio 6' },
        { id: 6, nombre: 'Ejercicio 7' },
        { id: 7, nombre: 'Ejercicio 8' },
      ],
      Modulo8: [
        { id: 8, nombre: 'Ejercicio 7' },
        { id: 9, nombre: 'Ejercicio 8' },
        { id: 10, nombre: 'Ejercicio 9' },
        { id: 11, nombre: 'Ejercicio de retención' },
      ],
      Modulo9: [
        { id: 12, nombre: 'Ejercicio 6' },
        { id: 13, nombre: 'Ejercicio 7' },
      ],
      Modulo10: [
        { id: 14, nombre: 'Ejercicio 5' },
        { id: 15, nombre: 'Ejercicio 6: De asociación' },
        { id: 16, nombre: 'Ejercicio 7: Raíces latinas' },
      ],
    },
  },
  avanzado: {
    nombre: 'Nivel 3 Avanzado',
    modulos: {
      Modulo11: [
        { id: 7, nombre: 'Ejercicio 7 - Rastreo' },
        { id: 8, nombre: 'Ejercicio 8 - Anticipe' },
        { id: 9, nombre: 'Ejercicio 9 - Mnemotecnia' },
        { id: 10, nombre: 'Ejercicio 10 - Memoria' },
      ],
      Modulo12: [{ id: 126, nombre: 'Ejercicio 6 - Mapas Mentales' }],
      Modulo13: [{ id: 137, nombre: 'Ejercicio 7 - Transformación Visual' }],
      Modulo14: [
        { id: 147, nombre: 'Ejercicio 7 - Cuadros Sinópticos' },
        { id: 148, nombre: 'Elaboración de Cuadros Sinópticos' },
        { id: 149, nombre: 'Columnas para Cuadros Sinópticos' },
      ],
      Modulo15: [
        { id: 156, nombre: 'Ejercicio 6 - Práctica' },
        { id: 157, nombre: 'Ejercicio 7 - Diferencie hechos' },
        { id: 158, nombre: 'Método de lectura aplicado' },
        { id: 159, nombre: 'Verificación Ejercicio 4 - Atención' },
      ],
    },
  },
};

export const crearClaveProgreso = (nivel, modulo, ejercicioId) => (
  `${nivel}_${modulo.toLowerCase()}_${ejercicioId}`
);

export const obtenerModulosNivel = (nivel, componentes = {}) => {
  const nivelConfig = NIVELES_EVALUACION[nivel];
  if (!nivelConfig) return {};

  return Object.fromEntries(
    Object.entries(nivelConfig.modulos).map(([modulo, ejercicios]) => [
      modulo,
      ejercicios.map((ejercicio) => {
        const clave = crearClaveProgreso(nivel, modulo, ejercicio.id);
        return { ...ejercicio, clave, componente: componentes[clave] };
      }),
    ])
  );
};
